import agentApi from "../apis/agentApi";

import { FETCH_SEGMENT_TYPES } from "./types";

export const fetchSegmentTypes = () => async (dispatch) => {
  const response = await agentApi.get("/api/segments");

  dispatch({ type: FETCH_SEGMENT_TYPES, payload: response.data });
};
